const CompanyTypes = {
    LOANS_ACTION_START:"LOANS_ACTION_START",
    LOANS_FETCH_DATA:"LOANS_FETCH_DATA",
    LOANS_FETCH_DATA_FAILED:"LOANS_FETCH_DATA_FAILED",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const LoansReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CompanyTypes.LOANS_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CompanyTypes.LOANS_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case CompanyTypes.LOANS_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export default LoansReducer;